<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Dashboard" title="Dashboard" />
		<div class="row">
			<div class="col-md-4 col-sm-6">
				<div class="card profile-box">
					<div class="card-body">
						<div class="media">
							<div class="media-body">
								<div class="greeting-user">
									<h4 class="f-w-600 mb-0">Welcome to <br>Trazio Networks</h4>
									<p>Here whats happing in your account</p>
									<div class="whatsnew-btn">
										<a class="btn btn-outline-white" @click="scrollToSection">Whats New !</a>
									</div>
								</div>
							</div>
							<div>
								<div class="clockbox">
									<svg id="clock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600">
										<g id="face">
											<circle class="circle" cx="300" cy="300" r="253.9"></circle>
											<path class="hour-marks" d="M300.5 94V61M506 300.5h32M300.5 506v33M94 300.5H60M411.3 107.8l7.9-13.8M493 190.2l13-7.4M492.1 411.4l16.5 9.5M411 492.3l8.9 15.3M189 492.3l-9.2 15.9M107.7 411L93 419.5M107.5 189.3l-17.1-9.9M188.1 108.2l-9-15.6"></path>
											<circle class="mid-circle" cx="300" cy="300" r="16.2"></circle>
										</g>
										<g id="hour">
											<path class="hour-hand" d="M300.5 298V142"></path>
											<circle class="sizing-box" cx="300" cy="300" r="253.9"></circle>
										</g>
										<g id="minute">
											<path class="minute-hand" d="M300.5 298V67"></path>
											<circle class="sizing-box" cx="300" cy="300" r="253.9"></circle>
										</g>
										<g id="second">
											<path class="second-hand" d="M300.5 350V55"></path>
											<circle class="sizing-box" cx="300" cy="300" r="253.9"></circle>
										</g>
									</svg>
								</div>
								<div class="badge f-10 p-0" id="txt"></div>
							</div>
						</div>
						<div class="cartoon">
							<img class="img-fluid" src="@/assets/images/dashboard/cartoon.svg" alt="vector women with leptop" />
						</div>
					</div>
				</div>
			</div>

			<div class="col-xl-8 col-md-8 box-col-6 col-ed-8">
				<div class="row">
					<div class="col-xl-12">
						<div class="card growth-wrap">
							<div class="card-header card-no-border growth-header">
								<div class="header-top">
									<h5>SIM Sales Growth</h5>
									<div>
										<div class="dropdown">
											<select class="form-select" v-model="year">
												<option :value="2026">2026</option>
												<option :value="2025">2025</option>
												<option :value="2024">2024</option>
												<option :value="2023">2023</option>
											</select>
										</div>
									</div>
								</div>
							</div>
							<div class="card-body pt-0">
								<div class="growth-wrapper">
									<apexchart height="200" type="line" :options="apexDashboard.options6" :series="apexDashboard.series6"></apexchart>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-6">
				<div class="card mini-stats-wid">
					<div class="card-body">
						<div class="media mb-3">
							<div class="media-body">
								<p class="tild-head text-primary" style="font-weight: 800;">Activation Requests Count</p>
							</div>

							<div class="float-end mm-cart-image text-primary" style="height: 52px; width: 50px;">
								<i class="icofont icofont-3x icofont icofont-chart-line-alt"></i>
							</div>
						</div>

						<div class="media mb-2">
							<div class="media-body">
								<p class="mb-0 ">Today's</p>
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-weight-400">{{today_activation_request}}</h6>
								</span>
							</div>
						</div>

						<div class="media mb-2">
							<div class="media-body">
								<p class="mb-0 ">This Week</p>
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-weight-400">{{week_activation_request}}</h6>
								</span>
							</div>
						</div>

						<div class="media mb-2">
							<div class="media-body">
								<p class="mb-0 ">This Month</p>
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-weight-400">{{month_activation_request}}</h6>
								</span>
							</div>
						</div>

						<div class="media mb-2">
							<div class="media-body">
								<p class="mb-0 ">Total</p>
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-weight-400">{{total_activation_request}}</h6>
								</span>
							</div>
						</div>

					</div>
				</div>
			</div>

			<div class="col-md-6">
				<div class="card mini-stats-wid">
					<div class="card-body">
						<div class="media mb-3">
							<div class="media-body">
								<p class="tild-head text-primary" style="font-weight: 800;">Whitelist Requests Count</p>
							</div>

							<div class="float-end mm-cart-image text-primary" style="height: 52px; width: 50px;">
								<i class="icofont icofont-3x icofont icofont-chart-line-alt"></i>
							</div>
						</div>

						<div class="media mb-2">
							<div class="media-body">
								<p class="mb-0 ">Today's</p>
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-weight-400">{{today_whitelist_request}}</h6>
								</span>
							</div>
						</div>

						<div class="media mb-2">
							<div class="media-body">
								<p class="mb-0 ">This Week</p>
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-weight-400">{{week_whitelist_request}}</h6>
								</span>
							</div>
						</div>

						<div class="media mb-2">
							<div class="media-body">
								<p class="mb-0 ">This Month</p>
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-weight-400">{{month_whitelist_request}}</h6>
								</span>
							</div>
						</div>

						<div class="media mb-2">
							<div class="media-body">
								<p class="mb-0 ">Total</p>
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-weight-400">{{total_whitelist_request}}</h6>
								</span>
							</div>
						</div>

					</div>
				</div>
			</div>

		</div>

		<div class="row">
			<div class="col-md-6">
				<div class="card top-offer">
					<div class="card-header card-no-border">
						<div class="header-top">
							<h5 class="m-0">Recent Activation Requests</h5>
							<!-- <div class="card-header-right-icon">
								<div class="dropdown">
									<select class="form-select" v-model="offer_drop">
										<option :value="0">All</option>
                                        <option :value="1">Today</option>
                                        <option :value="2">This week</option>
                                        <option :value="3">This Month</option>
                                    </select>
								</div>
							</div> -->
						</div>
					</div>
					<div class="card-body pt-0 offer-table">
						<div class="recent-table table-responsive currency-table">
							<table class="table">
								<thead>
									<tr align="center">
										<th class="f-light">Date</th>
										<th class="f-light">Count</th>
										<th class="f-light">Request ID</th>  
										<th class="f-light">Status</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="activation in activation_requests" :key="activation" align="center">
										<td>{{activation.request_date}}</td>
										<td>{{activation.count}}</td>
										<td>{{activation.request_id}}</td>
										<td>
											<span class="badge rounded-pill bg-info" v-if="activation.status == 0">Pending</span>
											<span class="badge rounded-pill bg-warning" v-else-if="activation.status == 1">Ongoing</span>
											<span class="badge rounded-pill bg-success" v-else-if="activation.status == 2">Completed</span>
										    <span class="badge rounded-pill bg-danger" v-else-if="activation.status == 3">Rejecetd</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>

			<div class="col-md-6">
				<div class="card top-offer">
					<div class="card-header card-no-border">
						<div class="header-top">
							<h5 class="m-0">Recent Whitelist Requests</h5>
							<!-- <div class="card-header-right-icon">
								<div class="dropdown">
									<select class="form-select" v-model="offer_drop">
										<option :value="0">All</option>
                                        <option :value="1">Today</option>
                                        <option :value="2">This week</option>
                                        <option :value="3">This Month</option>
                                    </select>
								</div>
							</div> -->
						</div>
					</div>
					<div class="card-body pt-0 offer-table">
						<div class="recent-table table-responsive currency-table">
							<table class="table">
								<thead>
									<tr align="center">
										<th class="f-light">Date</th>
										<th class="f-light">Count</th>
										<th class="f-light">Request ID</th>  
										<th class="f-light">Status</th>  
									</tr>
								</thead>
								<tbody>
									<tr v-for="whitelist in whitelist_requests" :key="whitelist" align="center">
										<td>{{whitelist.request_date}}</td>
										<td>{{whitelist.count}}</td>
										<td>{{whitelist.request_id}}</td>
										<td>
											<span class="badge rounded-pill bg-info" v-if="whitelist.status == 0">Pending</span>
											<span class="badge rounded-pill bg-warning" v-else-if="whitelist.status == 1">Ongoing</span>
											<span class="badge rounded-pill bg-success" v-else-if="whitelist.status == 2">Completed</span>
											<span class="badge rounded-pill bg-danger" v-else-if="whitelist.status == 3">Rejected</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="row" id="whats-new-section">
			<div class="col-md-3 col-12">
				<div class="card small-widget">
					<div class="card-body primary">
						<span class="f-light">New Orders</span>
						<div class="d-flex align-items-end gap-1">
							<h4>430</h4>
							<span class="font-primary f-12 f-w-500"><i class="icon-arrow-down"></i><span>-20%</span></span>
						</div>
						<div class="bg-gradient">
							<svg class="stroke-icon svg-fill">
								<use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${svgIcon1}`"></use>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-3 col-12">
				<div class="card small-widget">
					<div class="card-body warning">
						<span class="f-light">New Customers</span>
						<div class="d-flex align-items-end gap-1">
							<h4>15</h4>
							<span class="font-warning f-12 f-w-500"><i class="icon-arrow-up"></i><span>+50%</span></span>
						</div>
						<div class="bg-gradient">
							<svg class="stroke-icon svg-fill">
								<use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${svgIcon2}`"></use>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-3 col-12">
				<div class="card small-widget">
					<div class="card-body secondary">
						<span class="f-light">Average Orders</span>
						<div class="d-flex align-items-end gap-1">
							<h4>1900</h4>
							<span class="font-secondary f-12 f-w-500"><i class="icon-arrow-up"></i><span>+45%</span></span>
						</div>
						<div class="bg-gradient">
							<svg class="stroke-icon svg-fill">
								<use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${svgIcon3}`"></use>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-3 col-12">
				<div class="card small-widget">
					<div class="card-body success">
						<span class="f-light">Total Earnings</span>
						<div class="d-flex align-items-end gap-1">
							<h4>Rs.875486</h4>
							<span class="font-primary f-12 f-w-500"><i class="icon-arrow-up"></i><span>+30%</span></span>
						</div>
						<div class="bg-gradient">
							<svg class="stroke-icon svg-fill">
								<use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${svgIcon4}`"></use>
							</svg>
						</div>
					</div>
				</div>
			</div>
		</div> -->

		<!-- <div class="row">
			<div class="col-xxl-12 col-md-12 col-sm-12 box-col-12">
				<div class="appointment">
					<div class="dashboard-card card recent-order">
						<div class="card-header card-no-border">
							<div class="header-top">
								<div class="card-header-right-icon">
									<div class="dropdown">
										<select class="form-select" v-model="year">
											<option :value="2026">2026</option>
											<option :value="2025">2025</option>
											<option :value="2024">2024</option>
											<option :value="2023">2023</option>
										</select>
									</div>
								</div>
								
								<h5 class="m-0">Work Data</h5>

								<div class="card-header-right-icon">
									<div class="dropdown">
										<select class="form-select" v-model="type">
											<option value="">All Type</option>
											<option :value="1">New</option>
											<option :value="2">Repair</option>
											<option :value="3">Replacement</option>
										</select>
									</div>
								</div>
									
							</div>
						</div>
						
						<div class="card-body pt-0">
							<div class="row m-0 overall-card overview-card">
								<div class="col-xl-12 col-md-12 col-sm-12 p-0 box-col-12">
									<div class="chart-right">
										<div class="row">
											<div class="col-xl-12">
												<div class="card-body p-0">
													<div class="current-sale-container order-container">
														<div class="overview-wrapper">
															<apexchart height="345" type="line" :options="ecomDashboard.options2" :series="ecomDashboard.series2"></apexchart>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<!-- </div> -->

	</div>
</template>

<script>
import '@/assets/css/custom.css';
import { apexDashboard } from '@/data/comon';

	export default {
		name: "Dashbord1",
		components: {},
		data() {
			return {

				interval: "",
				greeting: "",
				time: "",
				
				errors: {}, 
				token : "",

				offer_drop: 1,

				svgIcon1: "new-order",
				svgIcon2: "customers",
				svgIcon3: "sale",
				svgIcon4: "profit",
				

				ecomDashboard: {

					options1: {
						labels: ['Ongoing', 'Draw Pending', 'Completed'],

						chart: {
							type: 'donut',
							height: 300,
						},
						dataLabels: {
							enabled: false
						},
						legend: {
							position: 'bottom',
							fontSize: '14px',
							fontFamily: 'Rubik, sans-serif',
							fontWeight: 500,
							labels: {
								colors: ["var(--chart-text-color)"],
							},
							markers: {
								width: 6,
								height: 6,
							},
							itemMargin: {
								horizontal: 7,
								vertical: 0
							},
						},
						stroke: {
							width: 10,
							colors: ["var(--light2)"],
						},
						plotOptions: {
							pie: {
								expandOnClick: false,
								donut: {
									size: '83%',
									labels: {
										show: true,
										name: {
											offsetY: 4,
										},
										total: {
											show: true,
											fontSize: '20px',
											fontFamily: 'Rubik, sans-serif',
											fontWeight: 500,
											label: 7,
											formatter: () => 'Total Campaigns'
										}
									},
								}
							}
						},
						states: {
							normal: {
								filter: {
									type: 'none',
								}
							},
							hover: {
								filter: {
									type: 'none',
								}
							},
							active: {
								allowMultipleDataPointsSelection: false,
								filter: {
									type: 'none',
								}
							},
						},
						colors: ["var(--theme-deafult)", "#FFA941", "#54BA4A"],
						responsive: [{
								breakpoint: 1630,
								options: {
									chart: {
										height: 360
									},
								}
							},
							{
								breakpoint: 1584,
								options: {
									chart: {
										height: 400
									},
								}
							},
							{
								breakpoint: 1473,
								options: {
									chart: {
										height: 250
									},
								}
							},
							{
								breakpoint: 1425,
								options: {
									chart: {
										height: 270
									},
								}
							},
							{
								breakpoint: 1400,
								options: {
									chart: {
										height: 320
									},
								}
							},
							{
								breakpoint: 480,
								options: {
									chart: {
										height: 250
									},

								}
							}
						]
					},
					series1: [2,4,1],


					// options2: {

					// 	chart: {
					// 		height: 300,
					// 		type: 'line',
					// 		stacked: false,
					// 		toolbar: {
					// 			show: false
					// 		},
					// 		dropShadow: {
					// 			enabled: true,
					// 			top: 2,
					// 			left: 0,
					// 			blur: 4,
					// 			color: '#000',
					// 			opacity: 0.08
					// 		}
					// 	},
					// 	stroke: {
					// 		width: [2, 2, 2, 2],
					// 		curve: 'smooth'
					// 	},
					// 	grid: {
					// 		show: true,
					// 		borderColor: 'var(--chart-border)',
					// 		strokeDashArray: 0,
					// 		position: 'back',
					// 		xaxis: {
					// 			lines: {
					// 				show: true
					// 			}
					// 		},
					// 		padding: {
					// 			top: 0,
					// 			right: 0,
					// 			bottom: 0,
					// 			left: 0
					// 		},
					// 	},
					// 	plotOptions: {
					// 		bar: {
					// 			columnWidth: '50%'
					// 		}
					// 	},
					// 	colors: ["#93f1e7", "#ffe333", "#ebeded",  "#fbba2f"],
						
					// 	fill: {
					// 		type: 'gradient',
					// 		gradient: {
					// 			shade: 'light',
					// 			type: "vertical",
					// 			opacityFrom: 0.4,
					// 			opacityTo: 0,
					// 			stops: [0, 100]
					// 		}
					// 	},
					// 	labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
						
					// 	markers: {
					// 		discrete: [
					// 			{
					// 				seriesIndex: 0,
					// 				dataPointIndex: 0,
					// 				fillColor: '#93f1e7',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 1,
					// 				dataPointIndex: 0,
					// 				fillColor: '#ffe333',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 2,
					// 				dataPointIndex: 0,
					// 				fillColor: '#ebeded',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 3,
					// 				dataPointIndex: 0,
					// 				fillColor: '#fbba2f',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 0,
					// 				dataPointIndex: 1,
					// 				fillColor: '#93f1e7',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, {
					// 				seriesIndex: 1,
					// 				dataPointIndex: 1,
					// 				fillColor: '#ffe333',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 2,
					// 				dataPointIndex: 1,
					// 				fillColor: '#ebeded',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 3,
					// 				dataPointIndex: 1,
					// 				fillColor: '#fbba2f',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 0,
					// 				dataPointIndex: 2,
					// 				fillColor: '#93f1e7',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, {
					// 				seriesIndex: 1,
					// 				dataPointIndex: 2,
					// 				fillColor: '#ffe333',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 2,
					// 				dataPointIndex: 2,
					// 				fillColor: '#ebeded',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 3,
					// 				dataPointIndex: 2,
					// 				fillColor: '#fbba2f',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 0,
					// 				dataPointIndex: 3,
					// 				fillColor: '#93f1e7',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, {
					// 				seriesIndex: 1,
					// 				dataPointIndex: 3,
					// 				fillColor: '#ffe333',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 2,
					// 				dataPointIndex: 3,
					// 				fillColor: '#ebeded',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 3,
					// 				dataPointIndex: 3,
					// 				fillColor: '#fbba2f',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 0,
					// 				dataPointIndex: 4,
					// 				fillColor: '#93f1e7',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, {
					// 				seriesIndex: 1,
					// 				dataPointIndex: 4,
					// 				fillColor: '#ffe333',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 2,
					// 				dataPointIndex: 4,
					// 				fillColor: '#ebeded',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 3,
					// 				dataPointIndex: 4,
					// 				fillColor: '#fbba2f',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 0,
					// 				dataPointIndex: 5,
					// 				fillColor: '#93f1e7',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, {
					// 				seriesIndex: 1,
					// 				dataPointIndex: 5,
					// 				fillColor: '#ffe333',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 2,
					// 				dataPointIndex: 5,
					// 				fillColor: '#ebeded',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 3,
					// 				dataPointIndex: 5,
					// 				fillColor: '#fbba2f',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 0,
					// 				dataPointIndex: 6,
					// 				fillColor: '#93f1e7',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, {
					// 				seriesIndex: 1,
					// 				dataPointIndex: 6,
					// 				fillColor: '#ffe333',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 2,
					// 				dataPointIndex: 6,
					// 				fillColor: '#ebeded',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 3,
					// 				dataPointIndex: 6,
					// 				fillColor: '#fbba2f',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 0,
					// 				dataPointIndex: 7,
					// 				fillColor: '#93f1e7',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, {
					// 				seriesIndex: 1,
					// 				dataPointIndex: 7,
					// 				fillColor: '#ffe333',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 2,
					// 				dataPointIndex: 7,
					// 				fillColor: '#ebeded',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 3,
					// 				dataPointIndex: 7,
					// 				fillColor: '#fbba2f',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 0,
					// 				dataPointIndex: 8,
					// 				fillColor: '#93f1e7',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, {
					// 				seriesIndex: 1,
					// 				dataPointIndex: 8,
					// 				fillColor: '#ffe333',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 2,
					// 				dataPointIndex: 8,
					// 				fillColor: '#ebeded',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 3,
					// 				dataPointIndex: 8,
					// 				fillColor: '#fbba2f',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 0,
					// 				dataPointIndex: 9,
					// 				fillColor: '#93f1e7',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, {
					// 				seriesIndex: 1,
					// 				dataPointIndex: 9,
					// 				fillColor: '#ffe333',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 2,
					// 				dataPointIndex: 9,
					// 				fillColor: '#ebeded',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 3,
					// 				dataPointIndex: 9,
					// 				fillColor: '#fbba2f',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 0,
					// 				dataPointIndex: 10,
					// 				fillColor: '#93f1e7',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, {
					// 				seriesIndex: 1,
					// 				dataPointIndex: 10,
					// 				fillColor: '#ffe333',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 2,
					// 				dataPointIndex: 10,
					// 				fillColor: '#ebeded',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 3,
					// 				dataPointIndex: 10,
					// 				fillColor: '#fbba2f',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 0,
					// 				dataPointIndex: 11,
					// 				fillColor: '#93f1e7',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, {
					// 				seriesIndex: 1,
					// 				dataPointIndex: 11,
					// 				fillColor: '#ffe333',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
					// 			{
					// 				seriesIndex: 2,
					// 				dataPointIndex: 11,
					// 				fillColor: '#ebeded',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 				sizeOffset: 3
					// 			}, 
					// 			{
					// 				seriesIndex: 3,
					// 				dataPointIndex: 11,
					// 				fillColor: '#fbba2f',
					// 				strokeColor: 'var(--white)',
					// 				size: 5,
					// 			},
								
					// 		],
					// 		hover: {
					// 			size: 5,
					// 			sizeOffset: 0
					// 		}
					// 	},
					// 	xaxis: {
					// 		type: 'category',
					// 		tickAmount: 10,
					// 		tickPlacement: 'between',
					// 		tooltip: {
					// 			enabled: false,
					// 		},
					// 		axisBorder: {
					// 			color: 'var(--chart-border)',
					// 		},
					// 		axisTicks: {
					// 			show: false
					// 		}
					// 	},
					// 	legend: {
					// 		show: false,
					// 	},
					// 	yaxis: {
					// 		min: 0,
					// 		tickAmount: 6,
					// 		tickPlacement: 'between',
					// 	},
					// 	tooltip: {
					// 		shared: false,
					// 		intersect: false,
					// 	},
					// 	responsive: [{
					// 		breakpoint: 1200,
					// 		options: {
					// 			chart: {
					// 				height: 250,
					// 			}
					// 		},
					// 	}]

					// },
					// series2: [
					// 	{
					// 		name: 'Diamond',
					// 		type: 'area',
					// 		data: [70,20,150,30,66,105,45,100,250,400,150,50]
					// 	},
					// 	{
					// 		name: 'Gold',
					// 		type: 'area',
					// 		data: [40,110,70,90,140,170,95,200,100,250,150,80]
					// 	},
					// 	{
					// 		name: 'Silver',
					// 		type: 'area',
					// 		data: [0,10,192,190,50,70,210,20,40,25,150,110]
					// 	},
					// 	{
					// 		name: 'Bronze',
					// 		type: 'area',
					// 		data: [120,50,90,220,160,80,0,200,400,250,150,130]
					// 	},
						
					// ],

					options2: {

						chart: {
							height: 300,
							type: 'line',
							stacked: false,
							toolbar: {
								show: false
							},
							dropShadow: {
								enabled: true,
								top: 2,
								left: 0,
								blur: 4,
								color: '#000',
								opacity: 0.08
							}
						},
						stroke: {
							width: [2, 2, 2, 2],
							curve: 'smooth'
						},
						grid: {
							show: true,
							borderColor: 'var(--chart-border)',
							strokeDashArray: 0,
							position: 'back',
							xaxis: {
								lines: {
									show: true
								}
							},
							padding: {
								top: 0,
								right: 0,
								bottom: 0,
								left: 0
							},
						},
						plotOptions: {
							bar: {
								columnWidth: '50%'
							}
						},
						colors: ["#FF3364", "#7064F5"],
						// "#FF3364", "#0dcaf0"
						fill: {
							type: 'gradient',
							gradient: {
								shade: 'light',
								type: "vertical",
								opacityFrom: 0.4,
								opacityTo: 0,
								stops: [0, 100]
							}
						},
						labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
						// labels: months

						markers: {
							discrete: [
								{
									seriesIndex: 0,
									dataPointIndex: 0,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								{
									seriesIndex: 1,
									dataPointIndex: 0,
									fillColor: '#7064F5',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 0,
									dataPointIndex: 1,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 1,
									fillColor: '#7064F5',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 0,
									dataPointIndex: 2,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 2,
									fillColor: '#7064F5',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 0,
									dataPointIndex: 3,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 3,
									fillColor: '#7064F5',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 0,
									dataPointIndex: 4,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 4,
									fillColor: '#7064F5',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 0,
									dataPointIndex: 5,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 5,
									fillColor: '#7064F5',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 0,
									dataPointIndex: 6,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 6,
									fillColor: '#7064F5',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 0,
									dataPointIndex: 7,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 7,
									fillColor: '#7064F5',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 0,
									dataPointIndex: 8,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 8,
									fillColor: '#7064F5',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 0,
									dataPointIndex: 9,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 9,
									fillColor: '#7064F5',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 0,
									dataPointIndex: 10,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 10,
									fillColor: '#7064F5',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 0,
									dataPointIndex: 11,
									fillColor: '#FF3364',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 11,
									fillColor: '#7064F5',
									strokeColor: 'var(--white)',
									size: 5,
								},
								
							],
							hover: {
								size: 5,
								sizeOffset: 0
							}
						},
						xaxis: {
							type: 'category',
							tickAmount: 10,
							tickPlacement: 'between',
							tooltip: {
								enabled: false,
							},
							axisBorder: {
								color: 'var(--chart-border)',
							},
							axisTicks: {
								show: false
							}
						},
						legend: {
							show: false,
						},
						yaxis: {
							min: 0,
							tickAmount: 6,
							tickPlacement: 'between',
						},
						tooltip: {
							shared: false,
							intersect: false,
						},
						responsive: [{
							breakpoint: 1200,
							options: {
								chart: {
									height: 250,
								}
							},
						}]

					},
					series2: [
						{
							name: 'Time Spend',
							type: 'area',
							data: [3100,1720,0,0,0,0,0,0,0,0,0,0]
						},
					],

				},

				apexDashboard: {

					options6: {
       
						chart: {
							height: 135,
							type: 'line',
							toolbar: {
								show: false
							},
							dropShadow: {
								enabled: true,
								enabledOnSeries: undefined,
								top: 5,
								left: 0,
								blur: 4,
								color: '#7366ff',
								opacity: 0.22
							},
						},
						grid: {
							yaxis: {
								lines: {
									show: false
								}
							},
						},
						colors: ["#5527FF"],
						stroke: {
							width: 3,
							curve: 'smooth'
						},
						xaxis: {
							type: 'category',
							categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan'],
							tickAmount: 10,
							labels: {
								style: {
									fontFamily: 'Rubik, sans-serif',
								},
							},
							axisTicks: {
								show: false
							},
							axisBorder: {
								show: false
							},
							tooltip: {
								enabled: false,
							},
						},
						fill: {
							type: 'gradient',
							gradient: {
								shade: 'dark',
								gradientToColors: ['#5527FF'],
								shadeIntensity: 1,
								type: 'horizontal',
								opacityFrom: 1,
								opacityTo: 1,
								colorStops: [{
										offset: 0,
										color: "#5527FF",
										opacity: 1
									},
									{
										offset: 100,
										color: "#E069AE",
										opacity: 1
									},
								]
							},
						},
						yaxis: {
							min: -10,
							max: 40,
							labels: {
								show: false
							}
						},
						responsive: [{
								breakpoint: 992,
								options: {
									chart: {
										height: 150,
									}
								},
							},
							{
								breakpoint: 768,
								options: {
									chart: {
										height: 200,
									}
								},
							}
						]
					},
					series6: [{
						name: 'Growth',
						data: [10, 5, 15, 0, 15, 12, 29, 29, 29, 12, 12, 15]
					}],
				},
				
				today_activation_request: "",
				week_activation_request: "",
				month_activation_request: "",
				total_activation_request: "",

				today_whitelist_request: "",
				week_whitelist_request: "",
				month_whitelist_request: "",
				total_whitelist_request: "",

				activation_requests: [],
				whitelist_requests: [],


				year: "2025",
				type: "",

				expense: {
					svgIcon : "expense",
					title :  "Expense",
					total_expense : "",
				},
				
				income: {
					svgIcon : "orders",
					title :  "Income",
					total_income : "",
				},

				months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],

			};

		},

		mounted() 
		{
			const HOURHAND = document.querySelector("#hour");
			const MINUTEHAND = document.querySelector("#minute");
			const SECONDHAND = document.querySelector("#second");
			
			function runClock() {
				var date = new Date();
				let hr = date.getHours();
				let min = date.getMinutes();
				let sec = date.getSeconds();
				let ampm = hr >= 12 ? "PM" : "AM";

				// Convert 24-hour to 12-hour format
				hr = hr % 12;
				hr = hr ? hr : 12; // If hour is 0, set it to 12

				let hrPosition = (hr * 360) / 12 + (min * (360 / 60)) / 12;
				let minPosition = (min * 360) / 60 + (sec * (360 / 60)) / 60;
				let secPosition = (sec * 360) / 60;

				HOURHAND.style.transform = "rotate(" + hrPosition + "deg)";
				MINUTEHAND.style.transform = "rotate(" + minPosition + "deg)";
				SECONDHAND.style.transform = "rotate(" + secPosition + "deg)";
				
				// Add leading zero for minutes and seconds if less than 10
				let formattedMinutes = min < 10 ? "0" + min : min;
				let formattedSeconds = sec < 10 ? "0" + sec : sec;

				document.getElementById("txt").innerHTML = hr + ":" + formattedMinutes + ":" + formattedSeconds + " " + ampm;
			}

			this.interval = setInterval(runClock, 1000);
		},
		unmounted() {
			clearTimeout(this.interval);
		},

		methods: {
			scrollToSection() {
				const section = document.getElementById('whats-new-section');
				if (section) {
					const topOffset = section.getBoundingClientRect().top + window.scrollY; // Calculate the exact position
					window.scrollTo({
					top: topOffset,
					behavior: 'smooth',
					});
				}
			},
		},

		 created() {
		 	this.fetchDashboard();
		 },
		 methods: {

			getToken() {
				if (localStorage.getItem('trazio')) {
				var trazio =  JSON.parse(localStorage.getItem('trazio'));
				if(trazio.token) {

					this.token = trazio.token;
					this.user = trazio;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

				} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
				}
			},


		 	fetchDashboard(page_url = null) {
		 		let url = "/trazio/dashboard";
		 		page_url = page_url || url;

		 		this.getToken();
		 		this.$axios
		 			.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
		 			.then((res) => {
		 				var responseData = res.data.data;
		 				console.log(responseData);
		 				this.today_activation_request = responseData.today_activation_request;
		 				this.week_activation_request = responseData.week_activation_request;
		 				this.month_activation_request = responseData.month_activation_request;
		 				this.total_activation_request = responseData.total_activation_request;

		 				this.today_whitelist_request = responseData.today_whitelist_request;
		 				this.week_whitelist_request = responseData.week_whitelist_request;
		 				this.month_whitelist_request = responseData.month_whitelist_request;
		 				this.total_whitelist_request = responseData.total_whitelist_request;

		 				this.activation_requests = responseData.recent_activation_requests;
		 				this.whitelist_requests = responseData.recent_whitelist_requests;
						
		 			})
		 			.catch((err) => console.log(err));
		 	},
			 
		 },
		
	};
</script>

<style>
	html {
	scroll-behavior: smooth;
	}
</style>

